// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODIFIED DATA : 07-12-2025
const PortFlioAtRiskTypes = {
	/** ***************GET PORTFOLIO AT RISK START ************* */
	PORTFOLIO_REPORT_START: 'portfolio_report_start',
	PORTFOLIO_REPORT_SUCCESS: 'portfolio_report_success',
	PORTFOLIO_REPORT_FAILURE: 'portfolio_report_failure',
	PORTFOLIO_REPORT_RESPONSE_RESET: 'portfolio_report_response_reset',
	PORTFOLIO_REPORT_RESPONSE_CHANGED: 'portfolio_report_response_changed',
	/** ***************GET PORTFOLIO AT RISK END ************* */
};

export default PortFlioAtRiskTypes;
